// AuthReducer.js
// -------------------------------
// Bevat alleen de authenticatie-gebruiker (uit JWT)

const initialState = {
    authUser: null     // komt uit JWT decode bij login
};

export default function authReducer(state = initialState, action) {
    switch (action.type) {

        case "SET_AUTH_USER":
            return {
                ...state,
                authUser: action.payload   // payload is gedecodeerde JWT user
            };

        case "LOGOUT_USER":
            return {
                ...state,
                authUser: null             // alleen authUser leegmaken
            };

        default:
            return state;
    }
}
